import sbtech from './sbtech.api.client-1.0.js';
import { fetchJson } from './../core/ajax-json.js';

function fetchToken(newLocation) {
	let goToLocation = '/';
	if (newLocation) {
		goToLocation = newLocation;
	}
	fetchJson('/sportsbook/status')
		.then((data) => {
			if (data.result.status === 'real') {
				sbtech.api.client.login(data.result.token);
			} else {
				console.info(data.result);
			}
			window.location.pathname = goToLocation;
		});
}

function getStatus() {
	fetchJson('/sportsbook/status')
		.then((data) => {
			sbtech.api.client.status(data.result);
		});
}

export default {
	fetchToken,
	getStatus
};



// WEBPACK FOOTER //
// ./mobile-core/src/sportsbook/sports-helper.js